// Constants for training groups
export const GROUP_TYPES = [
  'novice',
  'intermediate',
  'advanced',
  'elite',
  'masters',
  'junior',
  'development',
];

export const GROUP_TYPE_LABELS = {
  novice: 'Novice',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
  elite: 'Elite',
  masters: 'Masters',
  junior: 'Junior',
  development: 'Development',
};

// Member role options
export const MEMBER_ROLES = ['rower', 'coach'];

export const MEMBER_ROLE_LABELS = {
  rower: 'Rower',
  coach: 'Coach',
};
